import { PairedCostAdjustmentType } from '@aloft/toolkit-shared';

import { Typography } from '../../../summary/components/Typography.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { getPairedCostSettingsBreakdownText } from './getPairedCostSettingsBreakdownText.ts';

export const PairedCostSettingsBreakdown = ({
  results,
  type,
}: Tkv2PairedCostSummaryInterfaceV2 & { type: PairedCostAdjustmentType }) => (
  <Typography variant="body2" color="textSecondary">
    {getPairedCostSettingsBreakdownText(results, type)}
  </Typography>
);
